module.exports = __webpack_public_path__ + "static/media/coingossip-historical.7ce4e382.png";